import { Mui } from "@osu/react-ui";
import { useSelector, useDispatch } from 'react-redux';
import { setOpenDialog, setApiResult } from '../../services/graphql/slices/manage-applications-slice';
import { useBulkAssignUnassignApplicationsMutation } from "../../services/graphql/api";
import { addBusinessDays } from "../../util/functions";

export default function AssignUnassignDialog({ selectedReviewer = {} }) {
    const dispatch = useDispatch();
    const { openDialog, actionType, rowSelection, completionDate } = useSelector((state) => state.manageContentSlice);
    const selectedCount = Object.keys(rowSelection).length;
    const plural = selectedCount > 1 ? "s" : "";
    const dialogMessage = actionType === "assign"
        ? `Assigning ${selectedReviewer.label} to the selected ${selectedCount} application${plural}?`
        : `Unassigning ${selectedReviewer.label} from the selected ${selectedCount} application${plural}?`;

    const [apiCallBulkAssign] = useBulkAssignUnassignApplicationsMutation({ fixedCacheKey: "manage-applications-dialog" });

    async function confirmAction(e) {
        const selectedApplications = Object.values(rowSelection);

        const applicationKeys = selectedApplications.map(app => ({
            applicantEmployeeId: app.applicantEmployeeId,
            programId: app.programId,
            term: app.term
        }));

        const reviewerEmployeeId = selectedReviewer.reviewerEmployeeId;
        const completedByDueDate = addBusinessDays((completionDate ? new Date(completionDate) : new Date()).toISOString(), 0).toISOString();

        const variables = { applicationKeys, reviewerEmployeeId, completedByDueDate, actionType: actionType.toUpperCase() };

        apiCallBulkAssign(variables).then(result => { setApiResult(result?.data?.status); });

        e.preventDefault();
        e.stopPropagation();
        close();
    }

    function close() { dispatch(setOpenDialog(false)); }

    return (
        <Mui.Dialog
            open={openDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm">
            <Mui.DialogTitle id="alert-dialog-title">{actionType === "assign" ? "Assign Application" : "Unassign Application"}{plural}</Mui.DialogTitle>

            <Mui.DialogContent>
                <Mui.DialogContentText id="alert-dialog-description">{dialogMessage}</Mui.DialogContentText>
            </Mui.DialogContent>

            <Mui.DialogActions className="padding-2">
                <Mui.Button color="secondary" style={{ border: "none" }} variant="outlined" onClick={close}>Cancel</Mui.Button>
                <Mui.Button 
                    color="primary" 
                    style={{ border: "none" }} 
                    variant="contained" 
                    onClick={confirmAction}
                >
                    {actionType === "assign" ? "Assign" : "Unassign"}
                </Mui.Button>
            </Mui.DialogActions>
        </Mui.Dialog>
    );
}